export default function checkHttpError(response) {
  if ((response.status >= 200 && response.status < 300) || response.status === 304) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
